import CmsImage from '@/components/ui/CmsImage';
import { MEDIA_PLACEHOLDER } from '@/lib/media-placeholder';
import Link from 'next/link';
import type { BlogPost } from '../data/blogs';

interface BlogCardProps {
  post: BlogPost;
  locale: string;
}

export default function BlogCard({ post, locale }: BlogCardProps) {
  return (
    <article className="group overflow-hidden rounded-xl bg-transparent text-black transition duration-300 hover:-translate-y-1">
      <Link href={`/${locale}/blog/${post.slug}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-neutral-200 sm:aspect-[16/9]">
          <CmsImage
            src={post.image}
            alt={post.imageAlt}
            fill
            sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
            className="object-cover transition-transform duration-500 group-hover:scale-105"
            fallbackSrc={MEDIA_PLACEHOLDER}
          />
        </div>

        <div className="px-0 pb-1 pt-3">
          <time className="text-xs font-medium text-black/70">{post.date}</time>
          <h3 className="mt-2 line-clamp-3 text-base font-semibold leading-snug text-black transition-colors group-hover:text-[#ed1c22] sm:mt-3 sm:text-lg">
            {post.title}
          </h3>
          <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-black/55 sm:mt-4">
            {post.excerpt}
          </p>
        </div>
      </Link>
    </article>
  );
}
